// @ts-strict-ignore
import { CommentResponse } from 'fetchers/responses/comments.response';

import { parseDate } from 'utils/DateUtils';

import Comment from 'models/Comment';

export class CommentsParser {
  static parseComments = (unparsedComments: CommentResponse[]) =>
    unparsedComments.map(CommentsParser.parseComment);

  static parseComment(unparsedComment: CommentResponse) {
    return new Comment(
      unparsedComment.authorName,
      unparsedComment.id,
      unparsedComment.text,
      parseDate(unparsedComment.createdAt)
    );
  }
}
